export const unifyItaly = languages => languages.map(lang => (lang === 'it' ? 'it-it' : lang));

export const unifyLanguageCodes = languages =>
    languages.map(lang => {
        if (lang === 'br' || lang === 'eu') return lang;
        let sp = lang.split('-');
        return sp[0] + '-' + (sp.length > 1 ? sp[1] : sp[0]).toUpperCase();
    });
